<template>
    <div class="input-group">
        <span class="input-group-prepend">
            <img :src="image?.url || PLACEHOLDER_IMAGE_URL" class="image-preview">
        </span>
        <input
            ref="fileInput"
            type="file" 
            class="form-control-uniform"
            accept="image/*"
            multiple="false"
            @change="handleFileChange"
            hidden
        >
        <input type="text" class="form-control" :value="localFileName" :placeholder="$t('labels.empty')" readonly>

        <div class="input-group-append">
            <span class="action btn btn-light legitRipple" style="user-select: none;" @click="$refs.fileInput.click()">{{ $t('buttons.choose_file') }}</span>
        </div>
    </div>
</template>
<script>
import { PLACEHOLDER_IMAGE_URL } from "../../../constants";
import { httpClient } from "../../../services/HttpClient";

export default {
    name: 'ImageInputGroup',
    props: {
        image: {
            type: Object
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            PLACEHOLDER_IMAGE_URL,
            localFileName: ''
        }
    },
    computed: {
        fileName() {
            if (!this.image?.url) return '';
            return this.image.url.split('/').pop();
        }
    },
    methods: {
        handleFileChange(event) {
            const file = event.target.files[0];

            if (file) {
                this.localFileName = file.name;
            }
            
            let requestFile = new FormData();

            requestFile.append('file', file);
            requestFile.append('type', this.type);

            httpClient.post('/file/files', requestFile).then(response => {
                this.$emit('update:image', response.data.data);
            });
        }
    }
}
</script>
<style scoped>
.image-preview {
    border-radius: 5px;
    object-fit: cover;
    object-position: center;
    width: 38px;
    height: 38px;
}
</style>